import { Grid2, styled } from '@mui/material'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'

type Props = {}

const LoadingMessagesRow: React.FC<Props> = () => (
  <StyledCard>
    <CardContent>
      <Grid2 container spacing={8}>
        <RowLoader size={{ xs: 12 }}>
          <CircularProgress color="primary" size={50} />
        </RowLoader>
      </Grid2>
    </CardContent>
  </StyledCard>
)

const StyledCard = styled(Card)(() => ({
  padding: '5px',
}))

const RowLoader = styled(Grid2)(() => ({
  textAlign: 'center',
}))

export default LoadingMessagesRow
